const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Update+PLAY+Subscription+API


function updatePlaySubscription(orderId) {
    const url = '/api/users/profiles/playSubscription';
    return ufeApi.makeRequest(url, {
        method: 'PUT',
        body: JSON.stringify({ orderId: orderId })
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = updatePlaySubscription;
